module.exports = __webpack_public_path__ + "Icono_GroupMsj_Azul.png";